import { useField } from "formik";
import * as React from "react";

import {
  DatePicker,
  DatePickerProps,
} from "~/src/components/common/datepicker/DatePicker";

type Props = {
  name: string;
  disabled?: boolean;
  placeholder?: string;
};

export const FormikDateField: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ name, disabled, placeholder }) => {
  const [{ value }, { error, touched }, { setValue }] = useField<Date | null>(
    name
  );

  const handleChange = React.useCallback<DatePickerProps["onChange"]>(
    (value) => {
      setValue(value);
    },
    [setValue]
  );

  return (
    <DatePicker
      value={value}
      onChange={handleChange}
      error={touched ? error : undefined}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};
